import type { ComponentProps, ReactNode } from "react";
import { cn } from "@/shared/utils/cn";

export interface DetailSummaryProps extends ComponentProps<"dl"> {
  items: readonly { label: string; value: ReactNode }[];
}

export function DetailSummary({ items, className, ...props }: DetailSummaryProps) {
  return (
    <dl className={cn("grid grid-cols-[minmax(90px,0.6fr)_minmax(0,1fr)] gap-3.5 text-sm leading-relaxed", className)} {...props}>
      {items.map(({ label, value }) => (
        <div key={label} className="contents">
          <dt className="text-muted-foreground">{label}</dt>
          <dd className="min-w-0 font-semibold [overflow-wrap:anywhere]">{value}</dd>
        </div>
      ))}
    </dl>
  );
}
